module.exports = __webpack_public_path__ + "static/media/DataLion.d35941d0.png";